<template>
	<v-layout>
		<v-flex xs12>
			<v-container v-bind="{ [`grid-list-sm`]: true}" fluid class="remove-padding" :class="{ 'one-step-menu' : isSingleMenuPage }">
				<template>
					<v-layout row wrap class="addon-wrapper" data-cy="switchesGroupSubproducts">
						<template
							v-for="item in filterProducts(group.products)"
						>
							<v-flex
								:key="item.id"
								class="drinks-flex"
								:class="getItemClasses(item, crossSellProductToHighlight)"
							>
								<div v-if="isCrossSellHighlightedItemFn(crossSellProductToHighlight, item.id)" class="width-100 product-crosssel-highlight-box">
									{{ crossSellProductToHighlight.highlightProductLabel | translate(`crossSellProductToHighlight.${crossSellProductToHighlight.id}.options.highlightProductLabel`) }}
								</div>
								<div
									v-if="isSingleMenuPage"
									@click="!isMiniMenu ? changeSelection(item) : selectProduct(item.id)"
									class="sub-product-wrapper one-step-menu"
								>
									<div class="content-wrapper">
										<div class="one-step-menu-img">
											<img :src="backImg(item)[0]" :alt="item.displayName" />
										</div>
										<div class="group-wrapper" data-cy="item-price">
											<div>
												<div class="subproduct-name"
												     :data-cy="item.name"
												> {{item.name | translate(`product.${item.id}.name`)}}</div>
												<div class="subproduct-desc">{{item.description | translate(`product.${item.id}.description`)}}</div>
												<div :class="{'checked-text' : item.id === selectedSubproducts}">
													<span :class="{'old-price': shouldShowDiscountedPrice(item)}">{{ getSubproductPrice(item) }}</span>&nbsp;
													<span v-if="shouldShowDiscountedPrice(item)">+{{ discountPrice(item) }}</span>
												</div>
												<template v-if="hasIncludedPrice(item)">
													+{{formatPriceZero(hasIncludedPrice(item).inclPrice)}}
													({{includedPriceName(item)}})
												</template>
											</div>
											<div>
												<v-checkbox
													v-if="isMiniMenu"
													class="subproduct-checkbox subproduct-burger-checkbox"
													@click="selectProduct(item.id)"
													:key="item.id"
													:value="item.id"
													v-model="selectedSubproducts"
													hide-details
												>
												</v-checkbox>
												<v-checkbox
													v-else
													class="subproduct-checkbox subproduct-burger-checkbox"
													@click="() => {}"
													:key="item.id"
													:value="item.id"
													:input-value="selectedSubproducts && selectedSubproducts.productId ? selectedSubproducts.productId : selectedSubproducts"
													hide-details
												>
												</v-checkbox>
											</div>
										</div>
									</div>
									<div class="custom-content">
										<v-btn
											v-if="isSelectedProduct(item) && checkIfItemHasGroupsOrConfigurations(item)"
											class="black-btn btn-black"
											@click="toggleSubProductDetailsModal(true)"
										>
											{{ $t("shopComponents.gt2.productCatalog.productCatalogDefaultTile.tid100.customizeContent")}}
										</v-btn>
									</div>
								</div>
								<div v-else @click="!isMiniMenu ? changeSelection(item) : selectProduct(item.id)" class="sub-product-wrapper" >
									<v-badge
										v-if="productHasDiscountLabelFn(item)"
										class="family-discount-label-wrapper" :class="{'family-discount-label-wrapper-kiosk' : isKioskChannel, 'family-discount-label-long-text':  productHasDiscountLabelWithLongTextFn(item)}"
									>
										{{item.discount.options.productLabel | translate(`priceRule.${item.discount.discountId}.productLabel`)}}
									</v-badge>
									<div class="sub-product-content non-default">
										<v-card flat tile>
											<template v-if="productHasCustomLabelFn(item)">
												<LabelComponent
													:product="item"
													parentComponent="switches"
												>
													<v-img maintain-aspect :src="backImg(item)[0]" class="addons dimensions-fix" :alt="item.displayName" />
												</LabelComponent>
											</template>
											<template v-else>
												<v-img maintain-aspect :src="backImg(item)[0]" class="addons dimensions-fix" :alt="item.displayName" />
											</template>
										</v-card>
										<div class="group-wrapper" data-cy="item-price">
											<div class="subproduct-name"
											:data-cy="item.name"
											> {{item.name | translate(`product.${item.id}.name`)}}</div>
											<div class="subproduct-desc">{{item.description | translate(`product.${item.id}.description`)}}</div>
											<div :class="{'checked-text' : item.id === selectedSubproducts}">
												<span :class="{'old-price': shouldShowDiscountedPrice(item)}">{{ getSubproductPrice(item) }}</span>&nbsp;
												<span v-if="shouldShowDiscountedPrice(item)">+{{ discountPrice(item) }}</span>
											</div>
											<template v-if="hasIncludedPrice(item)">
													+{{formatPriceZero(hasIncludedPrice(item).inclPrice)}}
													({{includedPriceName(item)}})
											</template>
										</div>
									</div>
									<v-btn
										v-if="isSelectedProduct(item) && checkIfItemHasGroupsOrConfigurations(item)"
										class="black-btn btn-black"
										@click="toggleSubProductDetailsModal(true)"
									>
										{{ $t("shopComponents.gt2.productCatalog.productCatalogDefaultTile.tid100.customizeContent")}}
									</v-btn>
									<v-checkbox
										v-if="isMiniMenu"
										class="subproduct-checkbox subproduct-burger-checkbox"
										@click="selectProduct(item.id)"
										:key="item.id"
										:value="item.id"
										v-model="selectedSubproducts"
										hide-details
									>
									</v-checkbox>
									<v-checkbox
										v-else
										class="subproduct-checkbox subproduct-burger-checkbox"
										@click="() => {}"
										:key="item.id"
										:value="item.id"
										:input-value="selectedSubproducts && selectedSubproducts.productId ? selectedSubproducts.productId : selectedSubproducts"
										hide-details
									>
									</v-checkbox>
								</div>
							</v-flex>
							<v-dialog
								v-if="showSubProductDetails(item) && subProductDetailsModalShown"
								content-class="sub-product-details-modal"
								v-model="subProductDetailsModalShown"
							>
								<v-layout column class="kiosk-modal">
									<div class="black-background">
										<v-btn
											icon
											@click="toggleSubProductDetailsModal(false)"
											class="close-btn"
										>
											<v-icon class="close-image">close</v-icon>
										</v-btn>
										<v-flex xs12 v-if="item.groups.length">
											<div class="product-config-header">
												{{ $t("shopComponents.gt2.detailsTemplates.menuDetails.optionalItems") }}
											</div>
										</v-flex>
										<v-flex xs12>
											<product-group-check-box-grid
												v-for="gr in item.groups"
												:group="gr"
												:key="gr.id"
												:mainGroup="group"
												:subProduct="item"
												:productSelections="productSelections"
												:index="index"
												:changeSubGroupProductSelection="changeSubGroupProductSelection"
												:isMenu="isMenu"
											/>
										</v-flex>
										<v-flex xs12 v-if="item.configurations.length">
											<div class="product-config-header">
												{{ $t("shopComponents.gt2.detailsTemplates.menuDetails.includedItems") }}
											</div>
										</v-flex>
										<v-flex xs12>
											<product-config-check-box-grid
												v-for="config in item.configurations"
												:key="config.id"
												:config="config"
												:mainGroup="group"
												:subProduct="item"
												:selectedValues="checkBoxSelectedValues(config, group)"
												:changeConfigSelection="changeConfigSelection"
												:isMenu="isMenu"
											/>
										</v-flex>
										<v-flex xs12 class="flex-horizontal-end">
											<v-btn
												class="next-btn"
												@click="toggleSubProductDetailsModal(false)"
											>
												<div class="next-text">
													{{ $t("shopComponents.gt3.detailsTemplates.buttonNavigationConfiguration.stepperNext") }}
												</div>
												<div class="next-arrow flex-vertical-center">
													<img :src="`${staticPath}kiosk/images/icons/next-arrow.svg`" :alt="$t('common.scrollDown')">
												</div>
											</v-btn>
										</v-flex>
									</div>
								</v-layout>
							</v-dialog>
						</template>
					</v-layout>
				</template>
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
	import appConfig, {channelEnum} from "../../../../../appconfig";
	import {canBePickedUp, getBackImages, getStaticPath} from "../../../../../libraries/utils";
	import {formatPriceZero} from "../../../../../domains2/libraries/Utils";
	import ProductConfigCheckBoxGrid from "../ProductConfigCheckBoxGrid-gt3";
	import ProductGroupCheckBoxGrid from "../ProductGroupCheckBoxGrid-gt3";
	import ProductSelection from "../../../../../domains2/orders/ProductSelection";
	import * as Utils from "../../../../../libraries/utils";
	import {
		isCrossSellHighlightedItem,
		productHasCustomLabel,
		productHasDiscountLabel, productHasDiscountLabelWithLongText
	} from "../../../../../helper/ProductHelper";

	import LabelComponent from "../../../../UtilityComponents/Label";
	import {mapGetters} from "vuex";
	import {getProductPriceWithDiscounts} from "../../../../../libraries/globalTemplateSpecific/bm100/utils";
	import {savePickedBadge} from "../../../../../helper/RcmProductBadgeHelper";
	import {isPlusDiscountBetterThanProductDiscount, globalSunsetPlusDiscountRule} from "../../../../../helper/CatalogPricesHelper";
	import { productGroupsGetTotalPriceAndDiscount } from "../../../../../domains2/productGroups/productGroupsGetTotalPrice";

	export default {
		name: "SwitchesGroup-gt3",
		props: [
			"group",
			"changeGroupProductSelection",
			"changeSubGroupProductSelection",
			"changeConfigSelection",
			"productSelections",
			"productSelection",
			"index",
			"isMenu",
			"rootProduct",
			"isSingleMenuPage",
			"crossSellProductToHighlight"
		],
		components: {ProductConfigCheckBoxGrid, ProductGroupCheckBoxGrid, LabelComponent},
		data() {
			const self = this;

			return {
				subProductDetailsModalShown: false,
				selectedSubproducts: (() => {
					const selectedProductGroup = self.productSelection.groups.find(group => group.groupId === self.group.id);
					if (selectedProductGroup) {
						if (selectedProductGroup.selectedProducts && selectedProductGroup.selectedProducts.length > 0) {
							return selectedProductGroup.selectedProducts[0];
						} else {
							return self.group.options.defaultSelected;
						}
					} else {
						return self.group.options.defaultSelected || "";
					}
				})(),
				windowWidth: window.innerWidth
			};
		},
		computed: {
			...mapGetters([
				"featureToggles",
				"productCatalog",
				"globalSelectedShop",
				"isSubscribed"
			]),
			staticPath() {
				return getStaticPath();
			},
			channelAlias() {
				return appConfig.channelAlias();
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			},
			isMiniMenu() {
				return this.rootProduct && this.rootProduct.options && this.rootProduct.options.isMiniMenu;
			}
		},
		mounted(){
			const self = this;
			self.$nextTick(() => {
				window.addEventListener("resize", this.onResize);
			});
			self.selectFirstElementIfDefaultUnavailable();
		},
		methods: {
			isCrossSellHighlightedItemFn(crossSellProductToHighlight, productId) {
				return isCrossSellHighlightedItem(crossSellProductToHighlight, productId);
			},
			getItemClasses(item, crossSellProductToHighlight) {
				let classes = "";
				if(this.isSingleMenuPage) {
					classes += "xs12";
				}
				if(this.windowWidth > 1024) {
					classes += "xs4";
				} else {
					classes += "xs6";
				}
				if(this.isCrossSellHighlightedItemFn(crossSellProductToHighlight, item.id)) {
					classes += " product-crosssel-highlight-border";
				}
				return classes;
			},
			productHasDiscountLabelFn(item) {
				return productHasDiscountLabel(item);
			},
			formatPriceZero,
			productHasCustomLabelFn(item) {
				return productHasCustomLabel(item);
			},
			productHasDiscountLabelWithLongTextFn(product) {
				return productHasDiscountLabelWithLongText(product);
			},
			filterProducts(products) {
				const filteredProducts = products.filter(product => {
					return canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
				});
				// if crossSellProductToHighlight && crossSellProductToHighlight.highlightProductId is equal to item.id
				// put that item at the 2nd position in the array
				if (this.crossSellProductToHighlight && this.crossSellProductToHighlight.highlightProductId) {
					const highlightProductId = this.crossSellProductToHighlight.highlightProductId;
					const highlightProductIndex = filteredProducts.findIndex(product => product.id === highlightProductId);
					if (highlightProductIndex !== -1) {
						const highlightProduct = filteredProducts.splice(highlightProductIndex, 1)[0];
						filteredProducts.splice(1, 0, highlightProduct);
					}
				}
				return filteredProducts;
			},
			getImage(imageName) {
				return Utils.getMiscImageUrl(imageName);
			},
			toggleSubProductDetailsModal(status = !this.subProductDetailsModalShown) {
				this.subProductDetailsModalShown = !!status;
			},
			checkIfItemHasGroupsOrConfigurations(item) {
				return !!(item.configurations.length || item.groups.length);
			},
			shouldShowDiscountedPrice(item) {
				return this.isMiniMenu
					&& item.discount
					&& item.discount.voucherPattern.length === 0;
			},
			discountPrice(item) {
				const productWithDiscountedPrice = getProductPriceWithDiscounts(
					[item],
					[ProductSelection.createFromProduct(item)],
					this.productCatalog,
					["familyDiscount"]
				);
				return productWithDiscountedPrice[item.id] && formatPriceZero(productWithDiscountedPrice[item.id].discountPrice);
			},
			selectProduct(id) {
				if(!(this.selectedSubproducts || []).includes(id)) {
					this.selectedSubproducts = id;
				} else {
					this.selectedSubproducts = "";
				}
			},
			isSelectedProduct(item) {
				return (this.selectedSubproducts || {}).productId
					? this.selectedSubproducts.productId === item.id
					: (this.selectedSubproducts || []).includes(item.id);
			},
			showSubProductDetails(item) {
				if((this.selectedSubproducts || {}).productId) {
					return this.checkIfItemHasGroupsOrConfigurations(item) && (this.selectedSubproducts || {}).productId === item.id;
				}
				return this.checkIfItemHasGroupsOrConfigurations(item) && (this.selectedSubproducts || []).includes(item.id);
			},
			checkBoxSelectedValues(config, group) {
				const self = this;
				const selectedProducts = self.productSelection.groups
					.find(g => g.groupId === group.id).selectedProducts;
				return [...selectedProducts.find(sp => sp.configurations.find(c => c.configurationId === config.id)).configurations.find(c => c.configurationId === config.id).selectedValue];
			},
			onResize() {
				this.windowWidth = window.innerWidth;
			},
			hasIncludedPrice(item){
				if(item.foreignIds){
					if(item.foreignIds.onlinePosRules){
						if(item.foreignIds.onlinePosRules.cart){
							return item.foreignIds.onlinePosRules.cart.find(c=> c.inclPrice);
						}
						return false;
					}
					return false;
				}
				return false;
			},
			includedPriceName(item) {
				const cartObj = item.foreignIds.onlinePosRules.cart.find(c=> c.inclPrice) || {};
				return cartObj.name === "Pant" ? this.$t("common.pant") : cartObj.name;
			},
			getSubproductPrice(product) {
				const self = this;
				let price = (product.discount && product.discount.options.discountScope === "single")
					? product.priceStructure.priceInGroup
					: (isNaN(parseInt(product.getPriceInGroup())) ? 0 : product.getPriceInGroup());

				if (this.isMiniMenu) {
					price = product.priceStructure ? product.priceStructure.defaultPrice : product.price;
				}
				const difference = self.calculateDifference(price);

				if (difference > 0) {
					return " +" + this.formatPriceZero(difference);
				} else {
					return "";
				}
			},
			calculateDifference(price) {
				const self = this;
				const defaultSelectedProduct = self.group.products.find(product => product.id === self.group.options.defaultSelected);
				if (defaultSelectedProduct) {
					if (self.featureToggles.enableProductBestPriceInCatalogAndCart && self.isSubscribed && globalSunsetPlusDiscountRule(self.$store)) {
						const {price: menuPrice, discountValue} = productGroupsGetTotalPriceAndDiscount(self.rootProduct);
						const applyDiscount = !(isPlusDiscountBetterThanProductDiscount({store: this.$store, basePrice: menuPrice, discountPrice: menuPrice - discountValue}));
						return price - defaultSelectedProduct.getPriceInGroup({applyDiscount});
					}
					let priceOfDefaultSelectedProduct = defaultSelectedProduct.getPriceInGroup();
					if (this.isMiniMenu) {
						priceOfDefaultSelectedProduct = defaultSelectedProduct.priceStructure ? defaultSelectedProduct.priceStructure.defaultPrice : defaultSelectedProduct.price;
					}
					return price - priceOfDefaultSelectedProduct;
				} else {
					return price;
				}
			},
			backImg(product) {
				return getBackImages(product, this.isKioskChannel);
			},
			changeSelection(item) {
				const self = this;
				if(self.checkIfItemHasGroupsOrConfigurations(item)) {
					if((self.selectedSubproducts || {}).productId !== item.id) {
						self.selectedSubproducts = ProductSelection.createFromProduct(item);
					}
				} else {
					self.selectedSubproducts = item.id;
				}
				savePickedBadge({product: item});
			},
			/**
			 * if default element has been disabled by pickup rules than selectedSubproducts variable
			 * will have id that doesn't exist in group.products array
			 * thus take the first element from that array as a default
			 */
			selectFirstElementIfDefaultUnavailable(){
				if(this.isMiniMenu) {
					return;
				}
				const self = this;
				const selectedSubProductExists = self.group.products.find(p => {
					const selectedSubProductId = (self.selectedSubproducts || {}).productId ? self.selectedSubproducts.productId : self.selectedSubproducts;
					return p.id === selectedSubProductId;
				});
				if(!selectedSubProductExists){
					self.changeSelection(self.group.products[0]);
				}
			}
		},
		watch: {
			selectedSubproducts() {
				const self = this;
				if(self.selectedSubproducts || self.isMiniMenu) {
					self.changeGroupProductSelection(self.group, self.selectedSubproducts);
				}
			}
		}
	};
</script>
<style scoped lang="scss">
.black-btn {
	width: auto;
	height: 34px;
	text-transform: initial;
	font-size: 16px;
	position: absolute;
	bottom: 20px;
	right: 70px;
	border-width: 1px;
	margin: 0;
	padding: 0 10px;
	font-family: Dispatch;
	z-index: 1;
}
	.drinks-subheader{
		height: 50px;
		margin-bottom: 20px;
		border-radius: 3px;
		background-color: #161616;
		font-family: Dispatch-Bold;
		font-size: 22px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 50px;
		letter-spacing: normal;
		text-align: center;
		color: #9b9b9b;
	}
	.group-wrapper{
		position: absolute;
		bottom: 24px;
		padding-left: 16px;
		z-index: 1;
		max-width: 320px;
		.subproduct-name{
			margin-bottom: 14px;
			font-family: Dispatch-Bold !important;
			font-size: 20px;
		}
		.subproduct-desc{
			padding-right: 75px;
		}
	}
	.flex {
		text-align: center;
		position: relative;
		.v-card {
			background-color: transparent;
		}
	}

	.container.grid-list-sm .layout .flex {
		z-index: 1;
		padding: 0;
	}

	.container.remove-padding{
		padding: 0;
		.addon-wrapper{
			margin: 0 -7.5px 0 -7.5px;
			padding: 0;
			.flex{
				padding-left: 7.5px;
				padding-right: 7.5px;
				margin-bottom: 15px;
			}
		}
	}

	.layout.wrap {
		padding: 32px 10px 16px 0;
	}

	.accent--text {
		color: #ffc627 !important;
	}

	.background-surface-top {
		position: absolute;
		top: 0;
		width: 100%;
		height: 30%;
		pointer-events: none;
		-webkit-touch-callout: none;
		touch-action: none;
		-webkit-user-select: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			pointer-events: none;
			-webkit-touch-callout: none;
			touch-action: none;
			-webkit-user-select: none;
			user-select: none;
		}
	}

	.background-surface-bottom {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 30%;
		transform: rotate(180deg);
		pointer-events: none;
		-webkit-touch-callout: none;
		touch-action: none;
		-webkit-user-select: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			pointer-events: none;
			-webkit-touch-callout: none;
			touch-action: none;
			-webkit-user-select: none;
			user-select: none;
		}
	}

	.sub-product-wrapper {
		text-align: left;
		padding: 0 ;
		border-radius: 5px;
		border: solid 3px #26282c;
		background-color: #191a1b;
		max-width: initial;
		max-height: initial;
		width: 340px;
		height: 288px;
		img{
			width: 340px;
			height: 288px;
		}
		.sub-product-content {
			display: inline-block;
			padding-left: 0;
			width: 100%;
			height: 100%;
			font-family: Dispatch;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			color: #ffffff;
		}
		.addons {
			pointer-events: none;
			-webkit-touch-callout: none;
			touch-action: none;
			-webkit-user-select: none;
			user-select: none;
		}
		.v-input--checkbox {
			display: inline-block;
			text-align: left;
			position: absolute;
			bottom: 25px;
			right: 24.5px;
			z-index: 1;
			/deep/ .v-icon {
				font-size: 36px !important;
				width: 22px;
			}
		}
		.product-box{
			position: absolute;
			top: 0;
			margin-top: 109px;
			height: 182px;
			width: 340px;
			border-radius: 3px;
			background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, #000000 88%);
		}
	}
	.sub-product-content.non-default{
		.subproduct-desc{
			padding-bottom: 14px;
		}
	}

	.channel-kiosk {
		.v-input--checkbox {
			bottom: 18px;
    		right: 17.5px;
		}
	}
 .dimensions-fix {
	 height: 100% !important;
 }
 .close-image {
	color: white !important;
	font-size: 28px;
 }
</style>
